import { Event, Identifiable, VideoConferenceCallLink } from "@planzone/dto";
import { HttpClient, HttpMethods } from "../types/httpClient";

function getVideoConferenceCallLinks(httpClient: HttpClient) {
  return ({ uuid }: Identifiable<Event>) =>
    httpClient
      .sendHttpRequest<
        Identifiable<Event> & { attributes: { [key: string]: string } }
      >({
        endpoint: `/events/${uuid}`,
        method: HttpMethods.GET,
      })
      .then(({ attributes }) =>
        !!attributes.videoConferenceCallLinks
          ? JSON.parse(attributes.videoConferenceCallLinks)
          : [],
      );
}

export { getVideoConferenceCallLinks };
